// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-card-item[data-v-3f1d631c]{width:100%;height:auto;background-color:#fff;padding:14px 15px;margin:0;cursor:pointer}.center-right[data-v-3f1d631c]{display:flex;align-items:center;justify-content:flex-start}.title-text[data-v-3f1d631c]{color:rgba(0,0,0,.6)}.action-text[data-v-3f1d631c]{color:#1565c0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
